import React from 'react';
import { Icon, Button, Popconfirm, Modal, Input } from 'antd';
import styled, { css } from 'styled-components';
import { omit } from 'lodash';
import { compose, withState } from 'recompose';

import colors from 'utils/theme';

const styleTemplate = (bg, text, props) => (
  props.disabled ?
    css `font-family: Montserrat !important;width: 100%;` :
    css `
      font-family: Montserrat !important;
      background-color: ${bg} !important;
      border-color: ${bg} !important;
      color: ${text} !important;
      width: 100%;
      ${props.extraMargin ? 'margin-bottom: 10px !important;' : ''}
      &:hover {
        opacity: 0.85;
      }
    `
);

export const GreenButton = styled(Button)`
  ${props => styleTemplate(colors.green, colors.white, props)}
`;

export const RedButton = styled(Button)`
  ${props => styleTemplate(colors.red, colors.white, props)}
`;

export const YellowButton = styled(Button)`
  ${props => styleTemplate(colors.yellow, colors.white, props)}
`;

export const BlueButton = styled(Button)`
  ${props => styleTemplate(colors.blue, colors.white, props)}
`;

export const DefaultButton = styled(Button)`
  width: 100%;
  font-family: Montserrat !important;
  ${props => props.extraMargin && 'margin-bottom: 10px !important;'}
`;

export const OrangeButton = styled(Button)`
  ${props => styleTemplate(colors.orange, colors.white, props)}
`;

export const ThemeButton = styled(Button)`
  ${props => styleTemplate(props.theme.mainTheme, props.theme.white, props)}
`;

const Toggle = styled.a`
  font-size: ${props => props.theme.fontSize.button}px;
  color: ${props => props.theme.orange};
  user-select: none;
`;

const WithConfirm = ButtonComp => props => (
  <Popconfirm onConfirm={props.onClick} title={props.title || 'Are you sure?'} placement={props.placement || 'top'}>
    <ButtonComp {...omit(props, ['onConfirm', 'title', 'onClick', 'placement'])}>{props.children}</ButtonComp>
  </Popconfirm>
);

export const ToggleButton = props => (
  <Toggle {...props} >
    <Icon type={props.isShow ? 'minus-circle-o' : 'plus-circle-o'} /> {props.isShow ? 'Hide' : 'Show'} {props.text}
  </Toggle>
);

const WithModal = ButtonComp => props => (
  <div>
    <ButtonComp
      {...omit(props, ['onConfirm', 'title', 'onClick', 'placeholder', 'title', 'onOk'])}
      onClick={() => props.setIsVisible(true)}
    >{props.children}</ButtonComp>
    <Modal
      title={props.title}
      visible={props.isVisible}
      onOk={() => {
        this.textInput.value = '';
        props.setIsVisible(false);
        props.onOk(props.text);
      }}
      onCancel={() => {
        this.textInput.value = '';
        props.setIsVisible(false);
      }}
    >
      <Input
        onChange={e => props.setText(e.target.value)}
        ref={(input) => { this.textInput = input; }}
        placeholder={props.placeholder}
      />
    </Modal>
  </div>
);

const modalEnhancer = compose(
  withState('text', 'setText', ''),
  withState('isVisible', 'setIsVisible', false),
  WithModal,
);

export const WithConfirmGreenButton = WithConfirm(GreenButton);
export const WithConfirmRedButton = WithConfirm(RedButton);
export const WithConfirmBlueButton = WithConfirm(BlueButton);
export const WithConfirmDefaultButton = WithConfirm(DefaultButton);
export const WithConfirmOrangeButton = WithConfirm(OrangeButton);
export const WithConfirmYellowButton = WithConfirm(YellowButton);
export const WithInputModalRedButton = modalEnhancer(RedButton);
export const WithInputModalYellowButton = modalEnhancer(YellowButton);



// WEBPACK FOOTER //
// ./src/components/Core/Buttons.js